/**
 * Editorial filter overlay — right-aligned panel, mirrors overlay navigation.
 */
(function () {
  function initOverlayFilters() {
    const overlay = document.querySelector('[data-overlay-filters]');
    if (!overlay) return;

    const triggers = Array.from(document.querySelectorAll('[data-overlay-filter-trigger]'));
    const closeBtn = overlay.querySelector('[data-overlay-filter-close]');
    const applyBtn = overlay.querySelector('[data-overlay-filter-apply]');

    let lastTrigger = null;

    function setExpanded(expanded) {
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
    }

    function closeOtherOverlays() {
      const nav = document.querySelector('[data-overlay-nav]');
      if (nav?.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        nav.setAttribute('aria-hidden', 'true');
        document.querySelectorAll('[data-overlay-open], [data-overlay-trigger]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }

      const searchDropdown = document.querySelector('[data-search-dropdown]');
      if (searchDropdown?.classList.contains('is-open')) {
        searchDropdown.classList.remove('is-open');
        searchDropdown.setAttribute('aria-hidden', 'true');
        document.getElementById('header-component')?.removeAttribute('data-search-open');
        document.querySelectorAll('[data-search-dropdown-trigger]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
    }

    function openOverlay(invokedBy) {
      closeOtherOverlays();
      lastTrigger = invokedBy || lastTrigger;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
      setExpanded(true);
      closeBtn?.focus();
    }

    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
      setExpanded(false);
      lastTrigger?.focus();
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (overlay.classList.contains('is-open')) closeOverlay();
        else openOverlay(trigger);
      });
    });

    closeBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      closeOverlay();
    });

    applyBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      closeOverlay();
    });

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeOverlay();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (overlay.getAttribute('aria-hidden') === 'true') return;
      event.preventDefault();
      closeOverlay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverlayFilters);
  } else {
    initOverlayFilters();
  }
})();
